import URI from 'jsuri';

import type { EntityType } from 'bundles/unified-seo-content-common/types';
import { getEntityTypeFromEntityPathName } from 'bundles/unified-seo-content-common/utils';

type EntityParams = {
  slug: string;
  entityType: EntityType;
};

const getEntityParamsFromUrl = (URL: string): EntityParams => {
  const entityUri = new URI(URL);
  const [, entityPathName, slug] = entityUri.path().toString().split('/');
  // @ts-expect-error TS2345 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  const entityType = getEntityTypeFromEntityPathName(entityPathName);

  return {
    // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
    slug,
    entityType,
  };
};

export default getEntityParamsFromUrl;
